/**
 * Escapes special regex characters in a string to make it safe for use in RegExp constructor
 * @param text - The text to escape
 * @returns The escaped text with special regex characters escaped
 */
export const escapeRegexCharacters = (text: string): string => {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
